import { User } from './../index';

export class MinesiteUsers {
    public MinesiteId: number;
    public Users: User[] = [];
}
